import * as React from "react";

interface SvgComponentProps {
	[key: string]: any;
}

const StorageIcon: React.FC<SvgComponentProps> = (props) => (
	<svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 28c-3.356 0-6.194-.517-8.517-1.55C5.661 25.417 4.5 24.156 4.5 22.667V9.333c0-1.466 1.172-2.722 3.517-3.766C10.36 4.522 13.189 4 16.5 4c3.311 0 6.139.522 8.483 1.567 2.345 1.044 3.517 2.3 3.517 3.766v13.334c0 1.489-1.161 2.75-3.483 3.783C22.694 27.483 19.856 28 16.5 28Zm0-15.967c1.978 0 3.967-.283 5.967-.85 2-.566 3.122-1.172 3.366-1.816-.244-.645-1.36-1.256-3.35-1.834a21.354 21.354 0 0 0-5.983-.866 21.16 21.16 0 0 0-5.95.85c-1.944.566-3.072 1.183-3.383 1.85.31.666 1.439 1.277 3.383 1.833s3.928.833 5.95.833Zm0 6.634c.933 0 1.833-.045 2.7-.134a23.72 23.72 0 0 0 2.483-.383 18.149 18.149 0 0 0 2.234-.617c.7-.244 1.339-.522 1.916-.833v-4c-.577.311-1.216.589-1.916.833-.7.245-1.445.45-2.234.617a23.72 23.72 0 0 1-2.483.383c-.867.09-1.767.134-2.7.134-.933 0-1.844-.045-2.733-.134a23.49 23.49 0 0 1-2.517-.383 17.35 17.35 0 0 1-2.217-.617 12.092 12.092 0 0 1-1.866-.833v4c.555.311 1.177.589 1.866.833.69.245 1.428.45 2.217.617a23.49 23.49 0 0 0 2.517.383c.889.09 1.8.134 2.733.134Zm0 6.666c1.022 0 2.061-.077 3.117-.233a22.387 22.387 0 0 0 2.916-.617c.89-.255 1.634-.544 2.234-.866.6-.323.955-.65 1.066-.984v-3.266c-.577.31-1.216.589-1.916.833s-1.445.45-2.234.617c-.789.166-1.616.294-2.483.383-.867.089-1.767.133-2.7.133-.933 0-1.844-.044-2.733-.133a23.516 23.516 0 0 1-2.517-.383 17.366 17.366 0 0 1-2.217-.617 12.092 12.092 0 0 1-1.866-.833v3.3c.11.333.46.655 1.05.966.589.311 1.327.595 2.216.85a22.27 22.27 0 0 0 2.934.617c1.066.156 2.11.233 3.133.233Z"
    />
  </svg>
);
export default StorageIcon;
